<template>
    <div class="flex flex-wrap">
        <ProductModalsCard
            :title="detailsTitle"
            :content="detailsDescription"
            @click.native="openDetailsModal"
        />
        <ProductModalsCard
            :title="topTipsTitle"
            :content="topTipsDescription"
            @click.native="openTopTipsModal"
        />
        <ProductModalsCard
            :title="deliveryTitle"
            :content="deliveryDescription"
            @click.native="openDeliveryModal"
        />
        <client-only>
            <ProductModalsModal />
        </client-only>

    </div>
</template>

<script>
import ProductModalsModal from '~/components/ProductModalsModal';
import ProductModalsCard from '~/components/ProductModalsCard';

export default {

    components: {
        ProductModalsModal,
        ProductModalsCard,
    },

    props: {
        product: {
            type: Object,
            required: true,
        },
    },

    computed: {
        detailsTitle() {
            return this.product.details_modal_title || this.$store.getters['settings/getByKey']('default_details_modal_title') || 'Details';
        },
        detailsDescription() {
            return this.product.details_modal_description || this.$store.getters['settings/getByKey']('default_details_modal_description') || 'Explore details about this balloon';
        },
        detailsHtml() {
            return this.product.details_modal_html || this.$store.getters['settings/getByKey']('default_details_modal_html');
        },
        topTipsTitle() {
            return this.product.top_tips_modal_title || this.$store.getters['settings/getByKey']('default_top_tips_modal_title') || 'Tips & Tricks';
        },
        topTipsDescription() {
            return this.product.top_tips_modal_description || this.$store.getters['settings/getByKey']('default_top_tips_modal_description') || 'Caring for your balloon';
        },
        topTipsHtml() {
            return this.product.top_tips_modal_html || this.$store.getters['settings/getByKey']('default_top_tips_modal_html');
        },
        deliveryTitle() {
            return this.product.delivery_modal_title || this.$store.getters['settings/getByKey']('default_delivery_modal_title') || 'Delivery';
        },
        deliveryDescription() {
            return this.product.delivery_modal_description || this.$store.getters['settings/getByKey']('default_delivery_modal_description') || 'Learn about our delivery methods';
        },
        deliveryHtml() {
            return this.product.delivery_modal_html || this.$store.getters['settings/getByKey']('default_delivery_modal_html');
        },
    },

    methods: {
        openDetailsModal() {
            this.$modal.show('product-modals-modal', {
                title: this.detailsTitle,
                html: this.detailsHtml,
            });
        },
        openTopTipsModal() {
            this.$modal.show('product-modals-modal', {
                title: this.topTipsTitle,
                html: this.topTipsHtml,
            });
        },
        openDeliveryModal() {
            this.$modal.show('product-modals-modal', {
                title: this.deliveryTitle,
                html: this.deliveryHtml,
            });
        },
    },

};
</script>

<style lang="scss" scoped>
.card {
    @apply p-5 border text-center no-underline cursor-pointer rounded-none transition-fast;
    &:not(:last-child) {
        margin-right: -1px;
    }
    &:hover {
        @apply rounded;
    }
}
</style>
